import { createApi } from '@reduxjs/toolkit/query/react';
import { posApiInstance } from '@/shared/api/axios';
import { axiosBaseQuery } from './base-query';

export const posApi = createApi({
  reducerPath: 'posApi',
  baseQuery: axiosBaseQuery(posApiInstance),
  endpoints: (builder) => ({
    zones: builder.query<ZonesResponse, void>({
      query: () => ({
        url: `zones`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useZonesQuery } = posApi;

type ZonesResponse = {
  results: Zone[];
  count: 0;
};

export type Zone = {
  id: string;
  camera_id: string;
  zone_type: number;
  description: string;
  symmetric_key: string;
  zone_min_x: number;
  zone_min_y: number;
  zone_max_x: number;
  zone_max_y: number;
};
